import _import from './_import'
export default [
    {
        path: '/',
        component: _import('layout/index'),
        children: [
            {
                path: '/order',
                name: 'Order',
                component: _import('order'),
                children: [
                    {
                        path: 'list',
                        name: 'OrderList',
                        component: _import('order/list'),
                        meta: { title: '我的订单' }
                    },
                    {
                        path: 'detail',
                        name: 'OrderDetail',
                        component: _import('order/detail'),
                        meta: { title: '订单详情' }
                    },
                    {
                        path: 'untaxlist',
                        name: 'UnTaxList',
                        component: _import('order/untaxlist'),
                        meta: { title: '未开票明细' }
                    },
                    {
                        path: 'taxdetailcreate',
                        name: 'TaxDetailCreate',
                        component: _import('order/taxdetailcreate'),
                        meta: { title: '生成发票' }
                    },
                    {
                        path: 'taxlist',
                        name: 'TaxList',
                        component: _import('order/taxlist'),
                        meta: { title: '发票列表' }
                    },
                    {
                        path: 'taxlistdetail',
                        name: 'TaxListDetail',
                        component: _import('order/taxlistdetail'),
                        meta: { title: '发票明细' }
                    }
                ]
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/router/order.js